export namespace Binding {
  export const oneWay = "<";
  export const twoWay = "=";
  export const valueInput = "@";
  export const outputEvent = "&";
}
